module.exports = __webpack_public_path__ + "img/2025-11-17c_5.73e04215.jpg";